export { DetailsHeader } from './Header'
